export default __webpack_public_path__ + "static/media/tete18.9ce34c57.png";